<template>
  <permission-gate
    v-slot="{ canEdit }"
    moduleKey="cilindros"
  >
    <main-breadcrumb
      :items="items"
      showBackButton
    ></main-breadcrumb>
    <main-buttons-bar :align="'space-between'">
      <template #left>
        <custom-title>Listado de cilindros</custom-title>
      </template>
      <template #right>
        <el-tooltip
          v-if="!canEdit"
          content="El usuario no posee permisos de edición"
          placement="top"
        >
          <el-button
            type="primary"
            size="default"
            :icon="IconAdd"
            disabled
          >
            Nuevo cilindro
          </el-button>
        </el-tooltip>

        <template v-else>
          <el-button
            type="primary"
            size="default"
            :icon="IconAdd"
            @click="openModal"
            >Nuevo cilindro</el-button
          >
          <modal-new-cylinder
            v-model="modalVisible"
            @closed="handleModalClosed"
          ></modal-new-cylinder>
        </template>
      </template>
    </main-buttons-bar>
    <cylinders-filters></cylinders-filters>
    <custom-table
      :requestApi="findAllDesarrolloCilindroTipoHTTP"
      :requestArgs="cylinderFilters"
      :pathEdit="'/page/cylinders/edit'"
      :pathDetail="'/page/cylinders/detail'"
      :paramId="'Codigo'"
      :data="cylinderList"
      :columns="columns"
    ></custom-table>
  </permission-gate>
</template>

<script setup>
import {
  ref,
  onBeforeMount,
} from 'vue';
import { useRouter } from 'vue-router';
import { useCylinderStore } from '../stores/cylinders_store.js';
import { storeToRefs } from 'pinia';
import MainBreadcrumb from '@/shared/layout/main/main_breadcrum.vue';
import MainButtonsBar from '@/shared/layout/main/buttons_bar/main_buttons_bar.vue';
import CustomTable from '@/shared/components/custom_table.vue';
import CustomTitle from '@/shared/components/custom_title.vue';
import CylindersFilters from './cylinders_filters.vue';
import IconAdd from '~icons/mdi/add';
import ModalNewCylinder from './modal_new_cylinder.vue';
import PermissionGate from '@/shared/components/permission_gate.vue';

const cylinderStore = useCylinderStore();
const { cylinderList, cylinderFilters } = storeToRefs(cylinderStore);
const { firstCilindros, findAllDesarrolloCilindroTipoHTTP, resetFilter } = cylinderStore;
const items = [
  { label: 'Inicio', to: '/dashboard', replace: false },
  { label: 'Listado', to: null, replace: false },
];
const columns = [
  { field: 'CilindroTipo', label: 'Cilindro tipo', width: 180, sortable: true, isVisible: true },
  {
    field: 'CantidadCilindros',
    label: 'Cantidad cilindros',
    width: 180,
    sortable: true,
    isVisible: true,
  },
  { field: 'Desarrollo', label: 'Desarrollo', width: 180, sortable: true, isVisible: true },
  {
    field: 'CantidadMagneticos',
    label: 'Cantidad magneticos',
    width: 180,
    sortable: true,
    isVisible: true,
  },
  {
    field: 'CantidadAlmasStamping',
    label: 'Cantidad almas de stamping',
    width: 180,
    sortable: true,
    isVisible: true,
  },
  {
    field: 'CantidadCilindrosRelieveEnLinea',
    label: 'Cantidad cilindros de relieve en línea',
    width: 180,
    sortable: true,
    isVisible: true,
  },
  { field: 'Paso', label: 'Paso', width: 180, sortable: true, isVisible: true },
  { field: 'Engranaje', label: 'Engranaje', width: 180, sortable: true, isVisible: true },
];
const modalVisible = ref(false);
const openModal = () => {
  modalVisible.value = true;
};
const handleModalClosed = () => {
  modalVisible.value = false;
  firstCilindros();
};

onBeforeMount(async () => {
  resetFilter();
  await firstCilindros();
});
</script>

<style scoped></style>
